import { getParent } from '../misc/Utils'

export default class SiteFooter {
    constructor() {
        this.cacheDom()
        this.bindEvents()
    }

    cacheDom() {
        this.trigger = document.querySelectorAll('.footer-menu-trigger')
    }

    bindEvents() {
        Array.prototype.forEach.call(this.trigger, (element) => {
            element.addEventListener('click', this.toggleFooterMenu.bind(this))
        })
    }

    toggleFooterMenu(event) {
        const parent = event.target.parentNode
        const menuWrap = parent.querySelector('.footer-menu-wrap')

        if (parent.classList.contains('is-open')) {
            menuWrap.style.maxHeight = 0
            parent.classList.remove('is-open')
        } else {
            menuWrap.style.maxHeight = menuWrap.scrollHeight + 'px'
            parent.classList.add('is-open')
        }
    }
}
